import Locals from '../providers/Locals';

interface ErrorReport {
    source: string;
    message: string;
    stack?: string;
    componentStack?: string;
    url: string;
    pathname?: string;
    userAgent: string;
    errorType:
        | 'onerror'
        | 'unhandledrejection'
        | 'react_boundary'
        | 'upload_failure'
        | 'workflow_action_failure'
        | 'assignment_failure';
    metadata?: Record<string, unknown>;
}

function reportError(report: ErrorReport): void {
    try {
        const token = localStorage.getItem('odo_login_token');
        if (!token) return;

        const baseUrl = Locals.config().base_api_url;
        const truncatedReport = {
            ...report,
            message: report.message.slice(0, 1000),
            stack: report.stack?.slice(0, 5000),
            componentStack: report.componentStack?.slice(0, 5000)
        };

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        fetch(`${baseUrl}/api/v1/errors`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(truncatedReport),
            keepalive: true,
            signal: controller.signal
        })
            .then((res) => {
                // The body is never read; cancel it so a timeout abort racing
                // the response can't reject the orphaned stream unhandled.
                void res.body?.cancel().catch(() => undefined);
            })
            .finally(() => clearTimeout(timeoutId))
            .catch(() => {});
    } catch {
        // Swallow all errors — error reporting must never throw
    }
}

function reportCaughtError(error: unknown): void {
    reportError({
        source: 'frontend',
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        url: window.location.href,
        userAgent: navigator.userAgent,
        errorType: 'onerror'
    });
}

export { reportError, reportCaughtError };
export type { ErrorReport };
